/* eslint-disable import/prefer-default-export */

export const codeFlagMap = {
  pl: "PL",
  en: "GB",
  uk: "UA",
};
